import request from "./request";

export default {
  async add(data) {
    return await request.post("stations", data, false);
  },
  async update(userData) {
    return await request.put("stations", userData, false);
  },
  async updateStatus(userStatus) {
    return await request.post("stations/status", userStatus, false);
  },
  async updateAutoScheduler(data){
    return await request.post("stations/autoScheduler/status", data, false);
  },
  async getById(id) {
    return await request.get("stations/" + id, {}, false);
  },
  async getList(sellingproduct, buyingProduct) {
    var pageObj = {
      pageSize: -1,
    };
    return await request.post(
      `stations/search/${sellingproduct}/${buyingProduct}`,
      pageObj,
      false
    );
  },
  async updateSg(cascade) {
    return await request.put(
      "stations/sg/" + cascade.id,
      cascade.specificGravity,
      false
    );
  },
  async updateConversionFactorById(value) {
    return await request.post(
      `stations/lng-conversion-factor/update`,
      value,
      false
    );
  },
  async getStations() {
    return await request.post(`stations/select/CNG%7CCBG`, {}, false);
  },
  async getTerminals() {
    return await request.post(`stations/select/LNG`, {}, false);
  },
  async delete(id) {
    return await request.post(`stations/delete/${id}`, {}, false);
  },
  async getConverionFactor() {
    return await request.get(`stations/lng-conversion-factor`, {}, false);
  },
  async updateConversionFactor(value) {
    return await request.post(`stations/lng-conversion-factor`, value, false);
  },
  async getTerminalLocations() {
    return await request.get("geographical-areas/terminals", {}, false);
  },
  async getGeoAreaListByType(type) {
    return await request.get("geographical-areas/list/" + type, {}, false);
  },
  async getCustomers(product, locationId, customerId) {
    if (!customerId) customerId = [];
    var input = { customerIds: customerId, LocationIds: locationId };
    return await request.post(
      "stations/customers-list/" + product,
      input,
      false
    );
  },
  async getStationTypes() {
    return await request.get("station-type", {}, false);
  },
  async getUnits() {
    return await request.get("unit", {}, false);
  },
  async getSecondCustomers(id) {
    return await request.get(`stations/customers/${id}`, {}, false);
  },
  async getSuppliers(customerId, product, locationIds) {
    return await request.post(
      "stations/suppliers/" + customerId + "/" + product,
      locationIds,
      false
    );
  },
  async getVehicleList(locationIds, stationId, vehicleId, qty) {
    return await request.post(
      "stations/vehicle/" + stationId + "/" + vehicleId + "/" + qty,
      locationIds,
      false
    );
  },
  async getGeoAreaList() {
    return await request.get("geographical-areas", {}, false);
  },
  async createGArea(obj) {
    return await request.post("geographical-areas", obj, false);
  },
  async getActiveList(obj) {
    return await request.post("stations/active", obj, false);
  },
  async getActiveSourceList(obj) {
    return await request.post("stations/active/source", obj, false);
  },
  async getActiveCustomerList(obj) {
    return await request.post("stations/active/customer", obj, false);
  },
  async exportSource(pageObj, product) {
    return await request.exportFile(`export/source/${product}`, pageObj, false);
  },
  async exportCustomer(pageObj, product) {
    return await request.exportFile(
      `export/customer/${product}`,
      pageObj,
      false
    );
  },
};
